import { motion } from "framer-motion";

/**
 * Word-by-word masked reveal.
 * mode: "mount" (default) animates on load. "scroll" waits for scroll into view.
 */
export function RevealText({
  text = "",
  as: Tag = "span",
  className = "",
  wordClassName = "",
  stagger = 0.05,
  delay = 0,
  duration = 0.9,
  once = true,
  mode = "mount",
}) {
  const words = text.split(" ");
  const inViewProps =
    mode === "mount"
      ? { animate: { y: "0%" } }
      : { whileInView: { y: "0%" }, viewport: { once, amount: 0.15 } };

  return (
    <Tag className={className}>
      {words.map((word, i) => (
        <span
          key={i}
          className="inline-block overflow-hidden align-baseline"
          style={{ lineHeight: 0.95 }}
        >
          <motion.span
            className={"inline-block " + wordClassName}
            initial={{ y: "110%" }}
            {...inViewProps}
            transition={{
              duration,
              delay: delay + i * stagger,
              ease: [0.2, 0.8, 0.2, 1],
            }}
          >
            {word}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

/** Line-by-line reveal for pre-split lines */
export function RevealLines({
  lines = [],
  as: Tag = "h1",
  className = "",
  lineClassName = "",
  stagger = 0.12,
  delay = 0,
  duration = 1.0,
  once = true,
  mode = "mount",
}) {
  const inViewProps =
    mode === "mount"
      ? { animate: { y: "0%" } }
      : { whileInView: { y: "0%" }, viewport: { once, amount: 0.15 } };

  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden" style={{ lineHeight: 0.95 }}>
          <motion.span
            className={"block " + lineClassName}
            initial={{ y: "110%" }}
            {...inViewProps}
            transition={{
              duration,
              delay: delay + i * stagger,
              ease: [0.2, 0.8, 0.2, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export default RevealText;
